import axios from "axios"

// APPAUTH-001: the backend accepts requests only with a session token from Google sign-in (allow-list).
// One place attaches the token to every backend call (fetch and axios); EventSource gets it as ?access_token=.
// A 401 from the backend clears the token and opens the login page.

import { getToken, clearToken, isBackendUrl } from "./session"
export { BACKEND_URL, getToken, setToken, clearToken, withToken } from "./session"

function onUnauthorized() {
  clearToken()
  if (!window.location.pathname.startsWith("/login")) window.location.href = "/login"
}

let installed = false

export function installAuthTransport() {
  if (installed || typeof window === "undefined" || typeof window.fetch !== "function") return
  installed = true
  const original = window.fetch.bind(window)
  window.fetch = (input, init, ...rest) => {
    const url = typeof input === "string" ? input : (input && input.url) || ""
    const token = getToken()
    if (!token || !isBackendUrl(url)) return original(input, init, ...rest)
    const headers = new Headers((init && init.headers) || (typeof input !== "string" && input && input.headers) || undefined)
    if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`)
    return original(input, { ...(init || {}), headers }, ...rest).then((response) => {
      if (response && response.status === 401) onUnauthorized()
      return response
    })
  }
  axios.interceptors.request.use((config) => {
    const token = getToken()
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })
  axios.interceptors.response.use((response) => response, (error) => {
    if (error && error.response && error.response.status === 401) onUnauthorized()
    return Promise.reject(error)
  })
}

const checkAuth = () => {
  installAuthTransport()
  const TOKEN = getToken()
  const isPublicPage = window.location.pathname.startsWith("/login")

  if (!TOKEN && !isPublicPage) {
    window.location.href = "/login"
    return
  }
  axios.interceptors.request.use(function (config) {
    document.body.classList.add("loading-indicator")
    return config
  }, function (error) {
    return Promise.reject(error)
  })
  axios.interceptors.response.use(function (response) {
    document.body.classList.remove("loading-indicator")
    return response
  }, function (error) {
    document.body.classList.remove("loading-indicator")
    return Promise.reject(error)
  })
  return TOKEN
}

export default checkAuth
